<template>
  <div class="toaster" v-if="status">
    <div id="snackbar" :style="{ background: color }">
      <span class="close_button">
        <i class="material-icons" @click="status=false">close</i>
      </span>
      <p class="message">
        <i class="material-icons" :style="{ color: color }">{{iconName}}</i>
        {{msg}}
      </p>
    </div>
  </div>
</template>
<script>
import constant from "../../utils/constant";
export default {
  name: "CustomToaster",
  props: {
    dataValue: {
      type: Object
    }
  },
  data() {
    return {
      msg: "",
      iconName: "close",
      status: false,
      color: "black",      
    };
  },
  watch: {
    dataValue() {
      if (this.dataValue) {
        this.status = true;
        this.msg = this.dataValue.msg;
        this.color = this.dataValue.color;
        this.iconName = this.dataValue.iconName;
        setTimeout(
          () => {
            this.status = false;
          },
          this.dataValue.timeoutMs ? this.dataValue.timeoutMs : 3000
        );
      }
    }
  },
  mounted() {
    if (this.dataValue) {
      this.status = true;
      this.msg = this.dataValue.msg;
      this.color = this.dataValue.color;
      this.iconName = this.dataValue.iconName;
      setTimeout(
        () => {
          this.status = false;
        },
        this.dataValue.timeoutMs ? this.dataValue.timeoutMs : 3000
      );
    }
  }
};
</script>
<style scoped>
#snackbar {
  width: 100%;
  color: #fff;
  text-align: center;
  border-radius: 2px;
  padding: 14px;
  position: fixed;
  z-index: 99;
  padding-right: 30px;
  top: 0;
  left: 0;
  animation: ak 0.2s 1;
  box-shadow: rgba(0, 0, 0, 0.22) 0px 2px 10px 0px;
}
@keyframes ak {
  0% {
    transform: translateY(-100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0%);
    opacity: 1;
  }
}
#snackbar .close_button {
  top: 12px;
  right: 5px;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  position: absolute;
  z-index: 9;
}
#snackbar .close_button i {
  color: #ccc;
  font-size: 1.25em;
  font-weight: 600;
}
#snackbar .message {
  font-size: 0.938em;
  position: relative;
  padding-left: 29px;
  text-align: left;
}
#snackbar .message i {
  background: #fff;
  border-radius: 50%;
  font-size: 1em;
  padding: 2px 1px 1px;
  margin-right: 5px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
</style>